import { FileOutlined } from '@ant-design/icons';
import { Form } from 'antd';
import { Spin } from 'antd/lib';
import { UploadFile } from 'antd/lib/upload/interface';
import dayjs from 'dayjs';
import invariant from 'tiny-invariant';
import { useTranslation } from 'translations/hooks';

import { useAppContext } from 'business/contextProviders/useAppContext';
import { OngoingTask } from 'business/quality-control/pages/segment-import/hooks/data/use-ongoing-import-task';
import { Module_Enum } from 'generated/graphql';
import { formatDateWithMiddleDot } from 'technical/format/date';
import FileUpload from 'ui/form/fileUpload';

import style from './index.module.scss';
import { FileUploadFormValues } from './types';

export const FileUploadForm = ({
  ongoingTask,
  setOngoingTask,
}: {
  ongoingTask: OngoingTask | undefined;
  setOngoingTask: (task: OngoingTask) => void;
}) => {
  const { t } = useTranslation();

  const { currentConstructionSite } = useAppContext();
  invariant(currentConstructionSite, 'No construction site');

  const [form] = Form.useForm<FileUploadFormValues>();

  const initialValues = {
    projectId: currentConstructionSite.projectId,
  };

  const handleOnChange = (changedFiles: UploadFile[]) => {
    if (changedFiles.length > 0) {
      setOngoingTask({ createdAt: dayjs().format('YYYY-MM-DD HH:mm') });
    }
  };

  return (
    <Form<FileUploadFormValues>
      form={form}
      layout="vertical"
      initialValues={initialValues}
      className={style.uploadForm}
    >
      <Form.Item name="files">
        <FileUpload
          module={Module_Enum.QualityScan}
          uploadFolder={`segment-import-files/${form.getFieldValue('projectId')}`}
          accept=".xlsx"
          disableInput={ongoingTask !== undefined}
          multiple={false}
          onChange={handleOnChange}
        >
          {ongoingTask ? (
            <Spin />
          ) : (
            <FileOutlined style={{ color: '#000', fontSize: '32px' }} />
          )}

          <p>{t('qualityControl.segmentImport.cta.clickImport')}</p>

          {ongoingTask ? (
            <p className={style.alertMessage}>
              {t('qualityControl.segmentImport.warning.ongoingTask', {
                date: formatDateWithMiddleDot(ongoingTask.createdAt),
              })}
            </p>
          ) : null}
        </FileUpload>
      </Form.Item>
    </Form>
  );
};
